import store from "./store";
import filterStore from "./filterStore";

export const positionReferenceGroupText = () => {
    const selectedPositionAverage = filterStore.state.selectedPositionAverage;
    const selectedPlayerPosition = store.state.selectedPlayer.position;
    const referenceGroupText = filterStore.state.selectedReferenceGroup.text;

    const pos = selectedPositionAverage === "posAvg" ? selectedPlayerPosition : "";
    return `${referenceGroupText} ${pos}`.trim();
};

export const selectedReferenceGroupText = () => {
    return filterStore.state.selectedReferenceGroup.text;
};